import styled from 'styled-components';
import {
    AI_BRAND_GRADIENT_HORIZONTAL,
    AI_BRAND_GRADIENT_HORIZONTAL_HOVER,
} from '../../../aiMessageGenerator/aiGeneratorButton/AIGeneratorButton.css';

export const confirmButton = styled.button`
    width: 100%;
    padding: var(--space-sm) var(--space-lg);
    border: none;
    border-radius: 100px;
    background: ${AI_BRAND_GRADIENT_HORIZONTAL};
    color: var(--color-text-inverse-default);
    font-family: inherit;
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-bold);
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover:not(:disabled) {
        background: ${AI_BRAND_GRADIENT_HORIZONTAL_HOVER};
    }

    &:disabled {
        cursor: default;
        opacity: 0.5;
    }
`;
